<script setup>
import { ref } from 'vue'
import AppHeader from '@/Components/AppHeader.vue'
import HelpButton from '@/Components/HelpButton.vue'
import SupportChatModal from '@/Components/SupportChatModal.vue'
import ImpersonateBanner from '@/Components/ImpersonateBanner.vue'
import StripeConnectBanner from '@/Components/StripeConnectBanner.vue'
import ImpersonateModal from '@/Components/Modals/ImpersonateModal.vue'

/**
 * The signed-in frame.
 *
 * It used to be a sidebar with its own logo, its own account menu, its own help
 * link and its own set of links — a second product beside the public site, so
 * signing in changed the furniture rather than the content. The sidebar has
 * gone: the dashboards now carry the same header as every other page, and the
 * links that lived in the sidebar are in it.
 *
 * `flush` is unchanged — pages that manage their own scrolling (the lesson room,
 * the message thread) still fill the frame instead of sitting in a padded well.
 */
const showImpersonateModal = ref(false)
const showSupportModal = ref(false)
</script>

<template>
  <div :class="['flex flex-col bg-bg', $slots.flush ? 'h-screen overflow-hidden' : 'min-h-screen']">
    <ImpersonateBanner />
    <StripeConnectBanner />

    <AppHeader
      @open-support="showSupportModal = true"
      @open-impersonate="showImpersonateModal = true"
    />

    <main class="flex-1" :class="$slots.flush ? 'overflow-hidden' : ''">
      <template v-if="$slots.flush">
        <slot name="flush" />
      </template>
      <div v-else class="container-page py-6 md:py-10">
        <slot />
      </div>
    </main>

    <HelpButton />

    <SupportChatModal :open="showSupportModal" @close="showSupportModal = false" />
    <ImpersonateModal :show="showImpersonateModal" @close="showImpersonateModal = false" />
  </div>
</template>
